import { type FC, type ReactNode } from "react";

import { Text } from "@mantine/core";
import { FormattedNumber } from "react-intl";

import { type SubmissionQuotaContext } from "../../../shared/components/submission-quota/SubmissionQuotaContext";
import { SubmissionQuotaUpsell } from "../../../shared/components/submission-quota/SubmissionQuotaUpsell";
import { type SubmissionQuota, SubmissionQuotaSeverity } from "../../../shared/models/SubmissionQuota";

import { QuotaStatus } from "./QuotaStatus";
import styles from "./SubmissionQuotaQuickView.module.css";
import { Remaining } from "./messages.generated";

export const QuotaRow: FC<{ label: ReactNode; quota: SubmissionQuota; context: SubmissionQuotaContext }> = ({
    label,
    quota,
    context,
}) => {
    return (
        <div className={styles.row}>
            <div className={styles.primaryLine}>
                <Text component="span" size="xs" fw={500} className={styles.label}>
                    {label}
                </Text>
                <Text component="span" size="xs" className={styles.remaining}>
                    <Remaining remaining={<FormattedNumber value={quota.remaining} />} />
                </Text>
            </div>
            {quota.severity === SubmissionQuotaSeverity.Normal ? null : (
                <div className={styles.secondaryLine}>
                    <QuotaStatus severity={quota.severity} />
                    <SubmissionQuotaUpsell quota={quota} context={context} />
                </div>
            )}
        </div>
    );
};
